import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { AuthOtpVerification } from "../../../utilities";
import { UserDatailsType, UserDevicestype, UserRoleType, VerifyOtpType } from "../../../utilities/types";

const initialState = {
    isLoggedIn: false,
    message: "",
    UserDetails: {} as UserDatailsType,
    UserDevices: [] as UserDevicestype[],
    UserRole: {} as UserRoleType,
    UserFacilities: [] as any[],
    ButtonDisable: false,
    canViewSensitiveData: false,
    canDeleteSensitiveData: false
}

export const VerifyOtp = createAsyncThunk("VerifiedUser/VerifyOtp", (payload: VerifyOtpType) => AuthOtpVerification(payload))

const VerifyUserSlice = createSlice({
    name: "VerifiedUser",
    initialState,
    reducers: {
        resetVerifyUserSlice: () => initialState,
        signupUser: (state, action: PayloadAction<any>) => {
            state.isLoggedIn = false
            if (action.payload.status === 200) {
                let data = action.payload.data.data
                state.message = action.payload.data.message
                state.UserDetails = {
                    aadharNumber: data.aadharNumber,
                    addressId: data.addressId,
                    birthDate: data.birthDate,
                    countryCode: data.countryCode,
                    createdAt: data.createdAt,
                    email: data.email,
                    firstName: data.firstName,
                    gender: data.gender,
                    lastName: data.lastName,
                    phone: data.phone,
                    userImage: data.userImage,
                    defaultFacility: data.defaultFacility,
                    isPasswordReset: data.isPasswordReset,
                    addressLine1: data.address.addressLine1,
                    addressLine2: data.address.addressLine2,
                    city: data.address.city,
                    state: data.address.state,
                    country: data.address.country,
                    pincode: data.address.pincode,
                    landmark: data.address.landmark
                }
                state.UserDevices = data.userDevices
                state.UserRole = data.userRole
                state.UserFacilities = data.userFacilities
                state.canViewSensitiveData = data.canViewSensitiveData ?? false
                state.canDeleteSensitiveData = data.canDeleteSensitiveData ?? false
                data.userDevices.forEach((item: any) => {
                    item.deviceUuid === localStorage.getItem("device-uuid") && localStorage.setItem("authToken", JSON.stringify(item.authToken))
                })
            }
            else {
                state.message = action.payload.response.data.message
            }
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(VerifyOtp.pending, (state) => {
                state.isLoggedIn = true
                state.ButtonDisable = true
            })
            .addCase(VerifyOtp.fulfilled, (state, action: PayloadAction<any>) => {
                state.ButtonDisable = true
                state.isLoggedIn = false
                if (action.payload.status === 200) {
                    let data = action.payload.data.data
                    state.message = action.payload.data.message
                    state.UserDetails = {
                        aadharNumber: data.aadharNumber,
                        addressId: data.addressId,
                        birthDate: data.birthDate,
                        countryCode: data.countryCode,
                        createdAt: data.createdAt,
                        email: data.email,
                        firstName: data.firstName,
                        gender: data.gender,
                        lastName: data.lastName,
                        phone: data.phone,
                        userImage: data.userImage,
                        defaultFacility: data.defaultFacility,
                        isPasswordReset: data.isPasswordReset,
                        addressLine1: data.address.addressLine1,
                        addressLine2: data.address.addressLine2,
                        city: data.address.city,
                        state: data.address.state,
                        country: data.address.country,
                        pincode: data.address.pincode,
                        landmark: data.address.landmark
                    }
                    state.UserDevices = data.userDevices
                    state.UserRole = data.userRole
                    state.UserFacilities = data.userFacilities
                    state.canViewSensitiveData = data.canViewSensitiveData ?? false
                    state.canDeleteSensitiveData = data.canDeleteSensitiveData ?? false
                    data.userDevices.forEach((item: any) => {
                        item.deviceUuid === localStorage.getItem("device-uuid") && localStorage.setItem("authToken", JSON.stringify(item.authToken))
                    })
                }
                else {
                    state.message = action.payload.response.data.message
                    state.ButtonDisable = false
                }
            })
            .addCase(VerifyOtp.rejected, (state, action) => {
                state.isLoggedIn = false
                state.ButtonDisable = false
            })
    }
})

export default VerifyUserSlice.reducer
export const { resetVerifyUserSlice } = VerifyUserSlice.actions
export const { signupUser } = VerifyUserSlice.actions
